module.exports = __webpack_public_path__ + "img/msc.8cd80caa.png";